<template></template>

<script>
    import firebase from 'firebase'
    import Element from "./Element";
    import StorageBase from "./ModelStorageBase";

    // Vue.prototype.$super = VueSuperMethod
    // var changeCase = require('change-case');
    // var pluralize = require('pluralize');

    export default {
        mixins: [Element, StorageBase],
        name: 'model-element',
        props: {},
        data() {
            return {
                EndProgressing: false,
                canvasbase: null,
                //move
                movingElement: true,
                //panel
                propertyPanel: false,
                //multiEdit
                newEditUserImg: [],

                fullPath: null,
                params: null,
                paramKeys: null,

                messageRef: {},
                setImg: '',

                image: null,
                // queue complete
                STATUS_COMPLETE : true,
                elementValidationResults: [],
            }
        },
        created: function () {
            var me = this
            me.fullPath = this.$route.fullPath.split('/')
            me.params = this.$route.params
            me.paramKeys = Object.keys(me.params)
            // me.messageRef = firebase.database().ref(`/${me.$route.params.author}/${me.$route.params.projectName}`);
        },
        beforeDestroy() {
            // console.log("destory");
        },
        watch: {
            // "value": {
            //     deep: true,
            //     handler: _.debounce(function (newVal) {
            //         var me = this
            //         //TODO:
            //         // - 1. BoundedContext가 변경된다면 이전에 있던 BoundedContext에서는 삭제
            //         // - 2. name변경시에 파일 명 변경 되야함.
            //         // - 3. 변경시에 IDE에 있는 코드와 Generate되는 코드와 기존코드 Diff 후, Merge 되야 할 듯
            //         // - 4. Merge의 기준은?
            //         // - Diff가 해결 해 줄 문제..
            //         // - Move관련 Event처리 할 방법 - 아니면 그냥 Generate 처리 해버려도 상관은 없을것같음'
            //         // 그냥 전체 Generate / 전체 Diff / 전체 업로드
            //         // if (me.canvasbase.initLoad)
            //             // if (newVal.boundedContext) {
            //             //     this.$EventBus.$emit("generateCode", {
            //             //         "boundedContext": newVal.boundedContext,
            //             //         "element": newVal
            //             //     });
            //             // } else if(newVal.relationView) {
            //             //      this.$EventBus.$emit("generateCode", {
            //             //         "relation": newVal
            //             //     });
            //             // }
            //     }, 500)
            // },
            "value.elementView": {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.refreshImg()
                    var me = this
                    if (this.value.elementView) {
                        var positionX = me.value.elementView.x / 1000
                        var positionY = me.value.elementView.y / 1000
                        $(`#${me.value.elementView.id}`).css('transform-origin', `${positionX}% ${positionY}%`);
                        if (me.value.rotateStatus) {
                        } else {
                            $(`#${me.value.elementView.id}`).css('transform-origin', `${positionX}% ${positionY}%`);
                        }
                    }
                }
            },
            "movingElement": function () {
                this.refreshImg()
            },
            "alertImage": function () {
                this.refreshImg()
            },
            "newEditUserImg": function () {
                this.refreshImg()
            },
            "value.rotateStatus": function () {
                var me = this
                if (this.value.elementView) {
                    var positionX = this.value.elementView.x / 1000
                    var positionY = this.value.elementView.y / 1000
                    $(`#${this.value.elementView.id}`).css('transform-origin', `${positionX}% ${positionY}%`);
                    if (this.value.rotateStatus) {
                        $(`#${this.value.elementView.id}`).css('transform', `rotate(-30deg)`);
                        this.value.rotateStatus = true
                    } else if (this.value.rotateStatus == false) {
                        $(`#${this.value.elementView.id}`).css('transform-origin', `${positionX}% ${positionY}%`);
                        $(`#${this.value.elementView.id}`).css('transform', `rotate(0deg)`);
                        this.value.rotateStatus = false
                    }
                }
            },

        },
        mounted: function () {
            var me = this

            var elementId = me.value.elementView ? me.value.elementView.id : me.value.relationView.id

            // me.$EventBus.$on('es-EndProgressing', function (newVal) {
            //     me.EndProgressing = true
            // })

            me.$EventBus.$on(`${elementId}`, function (obj) {


                if ( obj.action == 'elementPush' ) {
                    //STATUS_COMPLETE_addElementPush
                    me.$nextTick(function () {
                        me.STATUS_COMPLETE = obj.STATUS_COMPLETE
                    })
                } else if ( obj.action == 'elementDelete' ) {
                    //STATUS_COMPLETE_elementDelete
                    me.$nextTick(function () {
                        me.STATUS_COMPLETE = obj.STATUS_COMPLETE
                    })
                } else if ( obj.action == 'elementMove' ) {
                    me.STATUS_COMPLETE = true
                    me.$nextTick(function () {
                        me.movingElement = true
                    })
                } else if ( obj.action == 'valueModify' ) {
                    me.$nextTick(function () {
                        me.STATUS_COMPLETE = obj.STATUS_COMPLETE
                    })
                } else if ( obj.action =='relationPush' ) {
                    me.$nextTick(function () {
                        me.STATUS_COMPLETE = obj.STATUS_COMPLETE
                    })
                } else if ( obj.action =='relationDelete' ) {
                    me.$nextTick(function () {
                        me.STATUS_COMPLETE = obj.STATUS_COMPLETE
                    })
                } else if ( obj.action =='relationMove' ) {
                    me.STATUS_COMPLETE = true
                    me.$nextTick(function () {
                        me.movingElement = true
                    })
                } else if (obj.action == 'userPanelOpen' || obj.action == 'userSelectedOn' || obj.action == 'userMovedOn') {
                    if(!me.newEditUserImg) {
                        me.newEditUserImg = []
                    }
                    if (me.newEditUserImg.findIndex(user => user.uid == obj.uid) == -1) {
                        me.newEditUserImg.push(obj)
                    }

                } else if (obj.action == 'userPanelClose' || obj.action == 'userSelectedOff' || obj.action == 'userMovedOff') {
                    if (me.newEditUserImg.length > 0) {
                        me.newEditUserImg.forEach(function (user, idx) {
                            if (user.uid == obj.uid) {
                                me.newEditUserImg.splice(idx, 1)
                            }
                        })
                    }
                }
            })


            // Rotate Element
            me.onRotateElement()

        },
        computed: {
            filteredElementValidationResults(){
                var me = this
                var levelSort = ['error','warning','info']
                try{
                    return me.elementValidationResults.sort(function compare(a, b) {
                        var aIdx = levelSort.findIndex(x=>x == a.level)
                        var bIdx = levelSort.findIndex(x=>x == b.level)
                        return aIdx - bIdx;
                    });
                }catch (e) {
                    return me.elementValidationResults
                }finally {
                    me.refreshImg()
                }
            },
            getEditUid(){
                if( localStorage.getItem('uid') ){
                    return localStorage.getItem('uid')
                }
                return null
            },
            editUserImg() {
                return this.newEditUserImg
            },
            getImg() {
                return this.setImg
            },
            storage() {
                if (this.canvasbase) {
                    return this.canvasbase.storage
                } else {
                    return 'localstorage'
                }
            },
            modelingProjectId(){
                if (this.canvasbase) {
                    return this.canvasbase.modelingProjectId
                }
                return this.params.projectId ? this.params.projectId : null
            },
            isCustomMoveExist() {
                if (this.canvasbase) {
                    if (this.isServerModeling && this.isQueueModeling) {
                        return !this.isReadModeling
                    }
                }
                return false
            },
            isReadOnly() {
                if (this.canvasbase) {
                    return this.canvasbase.readOnly
                } else {
                    return false
                }
            },
            isReadModeling() {
                if (this.canvasbase)
                    return this.canvasbase.isReadModeling
                return false
            },
            isClazzModeling() {
                if (this.canvasbase)
                    return this.canvasbase.isClazzModeling
                return false
            },
            isServerModeling() {
                if (this.canvasbase)
                    return this.canvasbase.isServerModeling
                return false
            },
            isQueueModeling() {
                if (this.canvasbase) {
                    return this.canvasbase.isQueueModeling
                } else {
                    return false
                }
            },
            isMembers() {
                var me = this
                var uid = me.canvasbase.userInfo.uid;
                if (me.canvasbase.information)
                    if (uid == me.canvasbase.information.author) {
                        return true
                    }
                var result = false;
                if (this.value.boundedContext) {
                    var keys = Object.keys(this.canvasbase.attachedLists);
                    keys.forEach(function (key) {
                        // if (me.canvasbase.attachedLists[key].name == me.value.boundedContext) {
                        console.log('me.canvasbase.attachedLists[key].name:: ',me.canvasbase.attachedLists[key].name)
                        if (me.canvasbase.attachedLists[key].name == me.value.boundedContext.name) {
                            me.canvasbase.attachedLists[key].members.forEach(function (member) {
                                if (member.uid == uid) {
                                    result = true
                                }
                            })
                        }
                    })
                } else if (me.value._type == 'org.uengine.modeling.model.BoundedContext') {
                    if (me.value.members)
                        me.value.members.forEach(function (member) {
                            if (member.uid == uid) {
                                result = true
                            }
                        })
                    else
                        result = false

                }
                if (me.value._type == 'org.uengine.modeling.model.BoundedContext') {
                    // console.log(me.value.name + " : " + result)

                }
                return result

            }
        },
        methods: {
            openPanel() {
                // var openPanelStatus = false
                // if(this.isServerModeling && this.isQueueModeling) {
                //     if(this.EndProgressing || this.value.name == "" || this.value.name.includes('BoundedContext')) {
                //         this.EndProgressing = true
                //         openPanelStatus = true
                //     }
                // } else {
                //     openPanelStatus = true
                // }
                // if(openPanelStatus) {
                    if(this.propertyPanel) this.propertyPanel = false
                    this.propertyPanel = true
                    this.staySelected = false
                // }
            },
            closePanel() {
                if(!this.propertyPanel) this.propertyPanel = true
                this.propertyPanel = false
            },
            deSelectedActivity: function () {
                var me = this

                if (me.value) {
                    me.selected = false
                    me.propertyPanel = false
                }
            },
            refreshImg() {
                var me = this
                me.setImg = 'refresh'
                me.$nextTick(function () {
                    if (me.setImg == 'refresh') {
                        me.setImg = ''
                    } else {
                        me.setImg = 'refresh'
                    }
                })
            },
            delayedMove(dx, dy, dw, dh, du, dlw, dl, dr) {
                var me = this
                try{
                    var offsetX, offsetY, offsetW, offsetH

                    var originX = me.value.elementView.x
                    var originY = me.value.elementView.y
                    var originW = me.value.elementView.width
                    var originH = me.value.elementView.height

                    if (dx == null && dy == null) {
                        // resize

                        if (Math.abs(dl) <= Math.abs(dr)) {
                            // 오른쪽으로 움직임
                            if (dr >= 0) {
                                offsetX = originX + (Math.abs(dl + dr) / 2.0)
                            } else {
                                offsetX = originX - (Math.abs(dl + dr) / 2.0)
                            }


                        } else if (Math.abs(dl) > Math.abs(dr)) {
                            // 왼쪽 으로 움직임
                            if (dl >= 0) {
                                offsetX = originX - (Math.abs(dl + dr) / 2.0)
                            } else {
                                offsetX = originX + (Math.abs(dl + dr) / 2.0)
                            }

                        }

                        if (Math.abs(dlw) <= Math.abs(du)) {
                            //위로 움직임
                            if (du >= 0) {
                                offsetY = originY - (Math.abs(du + dlw) / 2.0)
                            } else {
                                offsetY = originY + (Math.abs(du + dlw) / 2.0)
                            }

                        } else if (Math.abs(dlw) > Math.abs(du)) {
                            //아래로 움직임
                            if (dlw >= 0) {
                                offsetY = originY + (Math.abs(du + dlw) / 2.0)
                            } else {
                                offsetY = originY - (Math.abs(du + dlw) / 2.0)
                            }

                        }

                        offsetW = dw
                        offsetH = dh

                    } else if (dw == null && dh == null) {
                        //move
                        offsetX = originX + dx
                        offsetY = originY + dy
                        offsetW = originW
                        offsetH = originH
                    } else {
                        console.log('error Move & Resize')
                    }

                    var afterViewObj = {x: offsetX, y: offsetY, width: offsetW, height: offsetH}
                    var beforeViewObj = {x: originX, y: originY, width: originW, height: originH}

                    me.delayedMoveAction(beforeViewObj, afterViewObj)

                }catch (e) {
                    alert(`[Error] ModelElement-delayedMove: ${e}`)
                }
            },
            delayedMoveAction(beforeViewObj, afterViewObj){
                var me = this
                // Action
                if ( me.isCustomMoveExist ) {
                    me.movingElement = false
                    // move Queue
                    me.delayedMoveQueue(beforeViewObj, afterViewObj)
                }
            },
            delayedRelationMove(vertices) {
                var me = this
                try{
                    var originVertices = JSON.parse(JSON.stringify(me.value.relationView.value))
                    var newVertices = []
                    var offsetVertices

                    vertices.forEach(function (ver, index) {
                        newVertices.push([ver.x, ver.y])
                    })
                    offsetVertices = JSON.stringify(newVertices)

                    me.delayedRelationMoveAction(originVertices, offsetVertices)
                }catch (e) {
                    alert(`[Error] ModelElement - delayedRelationMove: ${e}`)
                }
            },
            delayedRelationMoveAction(originVertices, offsetVertices){
                var me = this
                if ( me.isCustomMoveExist ) {
                    me.movingElement = false

                    // relation Queue
                    me.delayedRelationMoveQueue(originVertices, offsetVertices)
                }
            },
            delayedMoveQueue(beforeViewObj , afterViewObj){
                var me = this
                try{
                    var types = me.value._type.split('.')
                    var pushObj =
                        {
                            action: 'elementMove',
                            elementType: types[types.length - 1],
                            elementName: me.value.name,
                            editUid: me.getEditUid,
                            elementId: me.value.elementView.id,
                            before: JSON.stringify(beforeViewObj),
                            after: JSON.stringify(afterViewObj),
                            timeStamp: Date.now(),
                        }
                    me.pushObject(`db://definitions/${me.modelingProjectId}/queue`, pushObj)
                }catch (e) {
                    alert(`[Error] ModelElement-DelayedMoveQueue PUSH: ${e}`)
                }
            },
            delayedRelationMoveQueue(originVertices , offsetVertices){
                var me = this
                try {
                    var pushObj =
                        {
                            action: 'relationMove',
                            editUid: me.getEditUid,
                            relationId: me.value.relationView.id,
                            before: originVertices,
                            after: offsetVertices,
                            timeStamp: Date.now(),
                        }
                    me.pushObject(`db://definitions/${me.modelingProjectId}/queue`, pushObj)
                }catch (e) {
                    alert(`[Error] ModelElement-DelayedRelationMoveQueue: ${e}`)
                }
            },
            onRotateElement(){
                if (this.value.elementView) {
                    var positionX = this.value.elementView.x / 1000
                    var positionY = this.value.elementView.y / 1000
                    $(`#${this.value.elementView.id}`).css('transform-origin', `${positionX}% ${positionY}%`);
                    if (this.value.rotateStatus) {
                        $(`#${this.value.elementView.id}`).css('transform', `rotate(-30deg)`);
                        this.value.rotateStatus = true
                    } else if (this.value.rotateStatus == false) {
                        $(`#${this.value.elementView.id}`).css('transform-origin', `${positionX}% ${positionY}%`);
                        $(`#${this.value.elementView.id}`).css('transform', `rotate(0deg)`);
                        this.value.rotateStatus = false
                    }
                }
            },
            onMoveElement(newObj,STATUS_COMPLETE){
                var me = this

                try{
                    me.value.elementView.x = newObj.x
                    me.value.elementView.y = newObj.y
                    me.value.elementView.width = newObj.width
                    me.value.elementView.height = newObj.height

                    me.$nextTick(function () {
                        me.movingElement = true
                        me.STATUS_COMPLETE = STATUS_COMPLETE
                    })
                }catch (e) {
                    alert(`[Error] ModelElement-onMoveElement: ${e}`)
                }
            },
            onMoveRelation(newObj,STATUS_COMPLETE){
                var me = this

                try{
                    me.value.relationView.value = newObj

                    me.$nextTick(function () {
                        me.movingElement = true
                        me.STATUS_COMPLETE = STATUS_COMPLETE
                    })
                }catch (e) {
                    alert(`[Error] ModelElement-onMoveRelation: ${e}`)
                }
            },
            onRemoveShape(model) {
                var me = this
                try {
                    if ( me.isCustomMoveExist ) {
                        me.removeShapeQueue()
                    } else {
                        me.removeShapeLocal()
                    }

                    me.validate()
                } catch (e) {
                    alert(`[Error] ModelElement-onRemoveShape: ${e}`)
                }
            },
            removeShapeLocal(){
                var me = this
                try{
                    var id = me.value.elementView ? me.value.elementView.id : me.value.relationView.id
                    var location = me.value.elementView ? me.canvasbase.value.elements : me.canvasbase.value.relations

                    if (location && id)
                        location[id] = null

                    if(me.initLoad){
                        me.changedTemplateCode = true
                    }
                }catch (e) {
                    alert(`[Error] ModelElement-removeShapeLocal: ${e}`)
                }
            },
            removeShapeQueue(){
                var me = this
                try{
                    var action = me.value.elementView ? 'elementDelete' : 'relationDelete'
                    var obj = {
                        action: action,
                        editUid: me.getEditUid,
                        timeStamp: Date.now(),
                        item: JSON.stringify(me.value)
                    }
                    me.pushObject(`db://definitions/${me.modelingProjectId}/queue`, obj)
                }catch (e) {
                    alert(`[Error] ModelElement-removeShapeQueue: ${e}`)
                }
            },
            getComponent(componentName) {
                let component = null
                let parent = this.$parent
                while (parent && !component) {
                    if (parent.$options.name === componentName) {
                        component = parent
                    }
                    parent = parent.$parent
                }
                return component
            },

        }
    }
</script>


<style scoped lang="scss" rel="stylesheet/scss">

</style>
